function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SortNumericDescIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 4v12h2V4h2.5L4 .5.5 4H3zM13.5 16c-.3 0-.5-.2-.5-.5V10h-.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5zM14.5 0h-3c-.3 0-.5.2-.5.5v3c0 .3.2.5.5.5H14v2h-2.5c-.3 0-.5.2-.5.5s.2.5.5.5h3c.3 0 .5-.2.5-.5v-6c0-.3-.2-.5-.5-.5zM12 1h2v2h-2V1z"
  }));
};
export default SortNumericDescIcon;